import React from "react";
import ContainerTimesafeInfo from "../HomeContainer/TimesafeInfo/ContainerTimesafeInfo";
import ContainerTsQuickBooking from "../HomeContainer/TsQuickBooking/ContainerTsQuickBooking";
import ContainerLatestTimeBookings from "../HomeContainer/LatestTimeBookings/ContainerLatestTimeBookings";
import ContainerWeekOverview from "./ContainerWeekOverview";
import "../HomeContainer/style.scss";
import "./style.scss";

// TimeSafe overview: balances, clocking in, week overview and the latest 25 own timebookings
function TimesafePage() {
    return (
        <div className="container container--dashboard timesafe-page">
            <div className="dashboard">
                <ContainerTimesafeInfo classes="ds-width-3" />
                <ContainerTsQuickBooking classes="ds-width-3" />
                <ContainerWeekOverview classes="ds-width-10" />
                <ContainerLatestTimeBookings classes="ds-width-10" anzahl={25} />
            </div>
        </div>
    );
}

export default TimesafePage;
